import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";
import { TableHead } from "@/components/ui/table";
import { cn } from "@/lib/utils";

export type SortDir = "asc" | "desc";

export function SortableHeader<F extends string>({
  field,
  label,
  sortField,
  sortDir,
  onClick,
  align = "left",
  className,
}: {
  field: F;
  label: string;
  sortField: F;
  sortDir: SortDir;
  onClick: (f: F) => void;
  align?: "left" | "right";
  className?: string;
}) {
  const active = sortField === field;
  const Icon = !active ? ArrowUpDown : sortDir === "asc" ? ArrowUp : ArrowDown;
  const ariaSort: "ascending" | "descending" | "none" = active
    ? sortDir === "asc"
      ? "ascending"
      : "descending"
    : "none";
  const ariaLabel = active
    ? `Sort by ${label}, currently ${ariaSort}. Click to toggle.`
    : `Sort by ${label}`;
  return (
    <TableHead
      aria-sort={ariaSort}
      className={cn(align === "right" ? "text-right" : undefined, className)}
    >
      <button
        type="button"
        onClick={() => onClick(field)}
        aria-label={ariaLabel}
        className={cn(
          "inline-flex items-center gap-1 hover:text-foreground transition-colors rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/40",
          align === "right" && "w-full justify-end",
        )}
      >
        {label}
        <Icon
          className={cn("size-3", active ? "opacity-80" : "opacity-30")}
          aria-hidden
        />
      </button>
    </TableHead>
  );
}
